import { Dialog, IconButton } from "@mui/material"
import { X } from "lucide-mui"
import React from "react"

import VenueGoogleMap from "@/components/public/venue/venue_google_map"
import i18n from "@/i18n"

const STYLES = {
  topBar: "relative flex shrink-0 items-center justify-center border-b border-[#f1f2f5] bg-white px-5 py-4",
  topBarTitle: "m-0 truncate px-10 text-base font-medium leading-4 text-[#19191b]",
  closeButton: "!absolute !right-2 !top-1/2 !-translate-y-1/2",
  map: "min-h-0 flex-1",
} as const

type ShowMapModalProps = {
  open: boolean
  onClose: () => void
  venueName: string
  latitude: number
  longitude: number
}

const ShowMapModal: React.FC<ShowMapModalProps> = ({ open, onClose, venueName, latitude, longitude }) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="sm"
    data-testid="public-venue-show-map-modal"
    sx={{
      "& .MuiDialog-container": {
        alignItems: "flex-end",
      },
    }}
    PaperProps={{
      sx: {
        width: "100%",
        margin: 0,
        borderTopLeftRadius: "10px",
        borderTopRightRadius: "10px",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        height: "calc(100dvh - 44px)",
        maxHeight: "calc(100dvh - 44px)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      },
    }}
  >
    <div className={STYLES.topBar} data-testid="public-venue-show-map-modal-top-bar">
      <h2 className={STYLES.topBarTitle}>{venueName}</h2>
      <IconButton
        onClick={onClose}
        className={STYLES.closeButton}
        aria-label={i18n.t("app.public.venue.info_modal.close")}
        data-testid="public-venue-show-map-modal-close"
      >
        <X className="h-5 w-5 text-[#19191b]" />
      </IconButton>
    </div>
    <div className={STYLES.map} data-testid="public-venue-show-map-modal-map">
      <VenueGoogleMap latitude={latitude} longitude={longitude} venueName={venueName} zoom={16} />
    </div>
  </Dialog>
)

export default ShowMapModal
